import {useEffect, useState} from 'react'
import {Col, DatePicker, Form, message, Row} from 'antd'
import {SFuncModal} from 'shj-components'
import dayjs from "dayjs";
import { projectExternalEmployeeupdateById} from "@/services/externalPerson.ts";
import moment from 'moment';

export interface SendDimissionModalProp {
    title: string
    callback: () => void,
    detailInfo: any
}

export interface SendDimissionModalDomProp {
    callback: () => void
    onClose: () => void
    detailInfo: any
}

const SendDimissionModalDom = (props: SendDimissionModalDomProp) => {
    const {onClose, callback, detailInfo} = props
    const [form] = Form.useForm()
    const [confirmLoading, setConfirmLoading] = useState<boolean>(false)
    // 提交
    const onFinish = () => {
        form.validateFields().then((values) => {
            setConfirmLoading(true)
            projectExternalEmployeeupdateById(
                {
                    id: detailInfo?.id,
                    actStatus: false, // 在职传true,离职传false
                    ...values
                }
            ).then((res) => {
                message.success(res?.message || "操作成功");
                setConfirmLoading(false);
                if (callback) {
                    callback()
                }
                onClose()
            }).catch(() => {
                setConfirmLoading(false);
            })
        })
    }
    return (
        <SFuncModal.Content
            onCancel={onClose}
            onOk={onFinish}
            confirmLoading={confirmLoading}
        >
            <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                initialValues={{
                    leaveDate: dayjs()
                }}
                labelCol={{span: 5}}
            >
                <Row gutter={12}>
                    <Col span={24}>
                        <Form.Item label="离职日期" name="leaveDate"
                                   rules={[{required: true, message: '请选择离职日期'}]}>
                            <DatePicker placeholder="请选择离职日期" style={{width: '100%'}} disabledDate={current => current && current >= moment()}/>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </SFuncModal.Content>
    )
}

export function sendDimissionModal(props: SendDimissionModalProp) {
    const {callback, detailInfo} = props
    let dialog: any = 0
    const onClose = () => {
        ;(dialog as any)?.destroy()
    }
    dialog = SFuncModal({
        width: 500,
        vanish: true,
        title: `离职确认`,
        content: (
            <SendDimissionModalDom onClose={onClose} callback={callback} detailInfo={detailInfo}/>
        ),
    })

    return dialog
}
